import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ModelDrawer from '../../ModelDrawer';
import { navigateToScene, SceneProps, SceneSideDrawerRoute } from '../scene-utils';
import { Model } from '../../hooks/useModelState';
import BulkImportSolidsPanel from './BulkImportSolidsPanel';
import { resetBulkImportSolidsSceneState } from './bulkImportSolidsSceneState';

const bulkImportSolidsSceneSideDrawerRoutes = (
  model: Model,
  _path: string,
  _baseUrl: string,
  currentDrawerState: boolean,
  setDrawerStateCallback: (isOpen: boolean) => void,
  handleBackCallback: () => void,
): SceneSideDrawerRoute[] => [
    {
      path: '*',
      isOpen: currentDrawerState,
      setIsOpen: setDrawerStateCallback,
      component: model && <BulkImportSolidsPanel model={model} onClose={handleBackCallback} />,
      backNavText: 'Stopes', // msgid; ModelDrawer translates it
      onBack: handleBackCallback,
    },
  ];

const SideDrawerContent = ({ props, model }: { props: SceneProps; model: Model }) => {
  const handleBack = () => {
    resetBulkImportSolidsSceneState();
    navigateToScene('DEFAULT', { model, context: props.context });
  };

  const routes = bulkImportSolidsSceneSideDrawerRoutes(
    model,
    props.meta.path,
    props.meta.url,
    props.context.state.drawerOpen,
    props.context.actions.setDrawerOpen,
    handleBack,
  );

  return (
    <Routes>
      {routes.map((route) => (
        <Route
          key={route.path}
          path={route.path}
          element={(
            <ModelDrawer
              isOpen={route.isOpen}
              setIsOpen={route.setIsOpen}
              backNavText={route.backNavText as string}
              onBack={handleBack}
            >
              {route.component}
            </ModelDrawer>
          )}
        />
      ))}
    </Routes>
  );
};

const sideDrawerContent = (
  props: SceneProps,
  model: Model,
): JSX.Element => (
  <SideDrawerContent props={props} model={model} />
);

export default sideDrawerContent;
